// @flow
import * as React from 'react'
import { Button, Paper } from '@/components'
import Strings, { Images } from '@/constants'
import styles from './styles.scss'


const NoRooms = ({ name, onClick }: {name: string, onClick: () => void }) => (
  <div className={styles.unavailableHotel}>
    <Paper className={styles.unavailablePaper}>
      <img src={Images.hotelWithPalms} alt={Strings.unavailableHotel} />
      <h3>{Strings.unavailable(name)}</h3>
      <Button title={Strings.backToHotels} onClick={onClick} />
    </Paper>
  </div>
)

export default NoRooms